import config from 'config';
const { VALIDATION_URL } = config;

import {
  StyledItemsEmpty,
  StyledEmpty,
  StyledEmptyLink,
  StyledEmptyText
} from 'components/grid-table/grid-table.style';

const ValidationsIsAny = () => {
  return (
    <StyledItemsEmpty>
      <StyledEmpty p={5}>
        <StyledEmptyText>
          You do not have any projects in this category.
        </StyledEmptyText>
        <StyledEmptyText>
          Please go to the{' '}
          <StyledEmptyLink target="_blank" href={VALIDATION_URL}>
            My Validations
          </StyledEmptyLink>{' '}
          to validate a project.
        </StyledEmptyText>
      </StyledEmpty>
    </StyledItemsEmpty>
  );
};

export default ValidationsIsAny;
